import React from 'react'

import { HelpCenterMainType } from '@application/Types/ComponentTypes'
import Container from '@mui/material/Container'

import { CategoryBox } from './CategoryBox'
import { CategoryWrapper, Title, Wrapper } from './HelpCenterMainView.styled'

export const HelpCenterMainView = (props: HelpCenterMainType): JSX.Element => {
    const { sectionTitle, categories } = props
    return (
        <Wrapper>
            <Container>
                <Title>{sectionTitle}</Title>
                <CategoryWrapper>
                    {categories.map((category) => (
                        <CategoryBox key={category.categoryUrl} {...category} />
                    ))}
                </CategoryWrapper>
            </Container>
        </Wrapper>
    )
}
